export const emailPattern = /[^\@]+@[^.]+(\.[^.]+)*/gm;
